
import { getLogTimestamp } from '@/utils/date'
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'RunLog',
  props: {
    level: {
      type: Number,
      required: true
    },
    message: {
      type: String,
      required: true
    },
    timestamp: {
      type: String,
      default: ''
    }
  },
  computed: {
    labelObj() {
      switch (this.level) {
        case 0:
          return { text: 'error', type: 'cherry' }
        case 1:
          return { text: 'warning', type: 'amber' }
        case 2:
          return { text: 'info', type: 'neutral' }
        default:
          return { text: 'info', type: 'neutral' }
      }
    }
  },
  methods: {
    getLogTimestamp
  }
})
